import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

import { JobDetailTab } from "entity/job/Job.api.types";

interface IJobDetailParams {
    jobId: number;
    defaultTab?: JobDetailTab;
}

interface IJobDetailsQueryParams {
    accessedFromContact?: boolean;
    accessedFromLead?: boolean;
    ownerInvoiceId?: number | null;
    openCondensed?: boolean;
    landOnSummaryAfterSave?: boolean;
    /** Creates the job on the new selections experience, ignoring the builder's default for new jobs */
    createWithSelectionsReimagined?: boolean;
}

const jobPath = "JobPage";
export const jobDetailPath = "/JobPage/:jobId/:defaultTab";
export const jobDetailRoute = createRoute<IJobDetailParams, IJobDetailsQueryParams>(
    getPathForAllPortals(`/${jobPath}/:jobId/:defaultTab`),
    "Job",
    {
        defaultTab: JobDetailTab.Job,
    },
);

export function isInJobRoute(pathname: string) {
    return pathname.includes(jobPath);
}
